
  Vue.prototype.seekerRelManagerConfigContactRequest = [
    { id: 0, fieldName: 'ContactFirstName', label: 'Nome referente', validators: [{ type: 'xxx_required' }] },
    { id: 1, fieldName: 'ContactLastName', label: 'Cognome referente', validators: [{ type: 'xxx_required' }] },
    {
      id: 2,
      fieldName: 'ContactCompany',
      label: 'Azienda',
      validators: [{ type: 'required' }]
    },
    {
      id: 3,
      fieldName: 'ContactEmail',
      label: 'Email',
      validators: [
        { type: 'required' },
        {
          type: 'regex',
          regex:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: 'Il formato del campo non è corretto.'
        }
      ]
    },
    // {
    //  id: 3,
    //  fieldName: 'ContactEmailConfirm',
    //  label: 'Conferma Email',
    //  validators: [
    //    { type: 'required' },
    //    {
    //      type: 'regex',
    //      regex: '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,})+)$',
    //      message: 'Il formato del campo non è corretto.'
    //    },
    //    {
    //      type: 'equalOtherFields',
    //      equalOtherFields: ['ContactEmail'],
    //      message: 'I due campi Email sono differenti'
    //    }
    //  ]
    // },

    {
      id: 4,
      fieldName: 'ContactMessage',
      label: 'Messaggio',
      hideIfEmpty: true,
      readOnly: true,
      inputType: 'textarea'
    }
  ]
